export const API = process.env.REACT_APP_API;
// export const API = process.env.REACT_APP_PROD_API;
